import {
  requestSurNameList,
  requestAddSurName
} from "@/apis/surNameSearch_api";

const state = {
  surNameList: []
};

const getters = {
  getSurNameList(state) {
    return state.surNameList;
  }
};

const mutations = {
  SUR_NAME_LIST(state, data) {
    state.surNameList = data.resultSurNameList;
  },
  SUR_NAME_INIT(state) {
    state.surNameList = [];
  }
};

const actions = {
  async REQUEST_SUR_NAME_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const { data } = await requestSurNameList(parameter);
      if (data !== null && data !== undefined && data.result === "success") {
        commit("SUR_NAME_LIST", data);
      } else {
        alert(data.message);
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_ADD_SUR_NAME({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const { data } = await requestAddSurName(parameter);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
